import { BoardTabs, type BoardTab } from "@/components/board/BoardTabs";
import { AvailabilityTab } from "@/components/makers/AvailabilityTab";
import { MakersTab } from "@/components/makers/MakersTab";
import { useQueryParams } from "@/hooks/useQueryParams";

type MakersPageTab = "makers" | "availability";

const MAKERS_TABS: BoardTab<MakersPageTab>[] = [
  { id: "makers", label: "Makers" },
  { id: "availability", label: "Availability" },
];

/**
 * Makers page - hosts the Makers and Availability tabs. The active tab is
 * driven by the `tab` query param so it survives reloads and is deep-linkable;
 * the default (no param) is the Makers board.
 */
export default function Makers() {
  const { get, setParam } = useQueryParams();
  // Page-specific param name so it doesn't collide with the Projects or Action
  // Items pages, which also use a tab param of their own.
  const tab: MakersPageTab = get("makersTab") === "availability" ? "availability" : "makers";

  const handleTabChange = (next: MakersPageTab) => {
    // Keep the URL clean: the Makers board is the default, so it carries no param.
    setParam("makersTab", next === "makers" ? null : next);
  };

  const tabs = (
    <BoardTabs
      tabs={MAKERS_TABS}
      active={tab}
      onChange={handleTabChange}
      ariaLabel="Makers sections"
    />
  );

  return tab === "availability" ? (
    <AvailabilityTab header={tabs} />
  ) : (
    <MakersTab header={tabs} />
  );
}
